import { checkIfIFrame } from "../../utils/checkIfIFrame";
import styles from "./index.module.css";
import clsx from "clsx";

function WidgetWrapper(props: React.ComponentProps<"div">) {
  const isIframe = checkIfIFrame();
  const style = clsx(styles["widget-wrapper"], {
    [styles["widget-wrapper--iframe"]]: isIframe
  });

  return <div className={style}>{props.children}</div>;
}

export default WidgetWrapper;
